import Clappr from '@clappr/player';
import { Events } from '../events/events.js';
import chromecastHTML from '../public/chromecast.html'

const TICK_INTERVAL = 500;

export class customPlayback extends Clappr.Playback {

  _player = null;

  get name() {
    return 'chromecast_playback';
  }

  get attributes() { return { class: 'chromecast-playback' }; }

  get isReady() {
    return true;
  }

  constructor(options) {
    super(options);
    this.src = options.src;
    this.currentMedia = {
      currentTime: 0,
      duration: 0,
      playerState: 'IDLE',
      liveSeekableRange: null
    }

    this.settings = {
      changeCount: 0,
      seekEnabled: true,
      left: ['playpause', 'position', 'duration'],
      default: ['seekbar'],
      right: []
    };

    this._closedCaptionsTracks = options.ccTracks || [];
    this._ccTrackId = -1;
    this._updateCCTrackID = options.updateCCTrackID;

    this.ready();

  }

  get closedCaptionsTracks() {
    return this._closedCaptionsTracks;
  }

  get closedCaptionsTrackId() {
    return this._ccTrackId;
  }

  set closedCaptionsTrackId(trackID) {
    this._ccTrackId = trackID;
    this._updateCCTrackID(trackID);
  }


  async loadCastInfo(t, content) {
    this._player = t;
    this.currentMedia = content;

    this.currentMedia.source = `https://storage.gra.cloud.ovh.net/v1/AUTH_8549ac1840b448048f7e9d07080dc0e5/gr1/${content.id}/hls/stream.m3u8`;    

    // Enviamos la info a Chromecast
    t.self.cast.sessionLoad(this.currentMedia);

    // Creamos el listener de mensajes de Chromecast
    t.self.cast.on(Events.CAST_MESSAGE, (message) => {

      // Si es STATUS
      if (message.type === 'STATUS') {
        this.currentMedia.currentTime = message.status.currentTime;
        this.currentMedia.duration = message.status.duration;
        this.currentMedia.playerState = message.status.playerState;
        this.stateChange();
      }
    });

    // Lanzamos el ready y buffering
    this.trigger(Clappr.Events.PLAYBACK_READY);

    this.isBuffering = true;
    this.trigger(Clappr.Events.PLAYBACK_PLAY);
    this.trigger(Clappr.Events.PLAYBACK_BUFFERING);
  }

  render() {

    this.$el.html(chromecastHTML);

    // Le metemos el CSS
    this.$el.css({
      'height': '100%',
    });

    return this;
  }

  play() {
    // Enviamos el play a Chromecast
    this._player.self.cast.play();
    this.trigger(Clappr.Events.PLAYBACK_PLAY);
  }

  pause() {
    this._player.self.cast.pause();
    this.stopTimer();
    this.trigger(Clappr.Events.PLAYBACK_PAUSE);
    this.currentMedia.playerState = 'PAUSED';
  }

  stop() {
    this.stopTimer();

    // Enviamos el stop a Chromecast
    this._player.self.cast.stop();
  }

  ready() {
    this._ready = true
    this.trigger(Clappr.Events.PLAYBACK_READY);
    this.trigger(Clappr.Events.PLAYBACK_HIGHDEFINITIONUPDATE, this.isHighDefinitionInUse())
  }

  seek(time) {
    this.stopTimer();

    // Ajustamos nuestro currentTime
    this.currentMedia.currentTime = time;

    // Enviamos el seek a Chromecast
    this._player.self.cast.seek(time);
  }

  seekPercentage(percentage) {
    if (percentage >= 0 && percentage <= 100) {
      let duration = this.getDuration();
      this.seek(percentage * duration / 100);
    }
  }

  startTimer() {
    this.timer = setInterval(() => this.updateMediaControl(), TICK_INTERVAL);
  }

  stopTimer() {
    clearInterval(this.timer);
    this.timer = null;
  }

  getDuration() {
    return this.currentMedia.duration;
  }

  getCurrentTime() {
    return this.currentMedia.currentTime;
  }

  isPlaying() {
    return this.currentMedia.playerState === 'PLAYING' || this.currentMedia.playerState === 'BUFFERING';
  }

  getPlaybackType() {
    return this.currentMedia.liveSeekableRange ? Clappr.Playback.LIVE : Clappr.Playback.VOD;
  }

  stateChange() {

    if (this.isPlaying() && !this.timer) {
      this.startTimer();
    }

    if (this.currentMedia.playerState === 'BUFFERING') {
      this.isBuffering = true;
      this.trigger(Clappr.Events.PLAYBACK_BUFFERING);
    } else if (this.currentMedia.playerState === 'PLAYING') {
      if (this.isBuffering) {
        this.isBuffering = false;
        this.trigger(Clappr.Events.PLAYBACK_BUFFERFULL);
      }
      if (this.prevState !== this.currentMedia.playerState) {
        this.trigger(Clappr.Events.PLAYBACK_PLAY);
      }
    } else if (this.currentMedia.playerState === 'IDLE') {
      if (this.isBuffering) {
        this.isBuffering = false;
        this.trigger(Clappr.Events.PLAYBACK_BUFFERFULL);
      }
      this.trigger(Clappr.Events.PLAYBACK_ENDED);
    } else if (this.currentMedia.playerState === 'PAUSED') {
      if (this.prevState !== this.currentMedia.playerState) {
        this.trigger(Clappr.Events.PLAYBACK_PAUSE);
      }
    }

    this.prevState = this.currentMedia.playerState;
  }

  updateMediaControl() {
    let position = this.currentMedia.currentTime;
    let duration = this.currentMedia.duration;
    this.trigger(Clappr.Events.PLAYBACK_TIMEUPDATE, { current: position, total: duration });

    // Este sería la barra de contenido cargado
    // this.trigger(Clappr.Events.PLAYBACK_PROGRESS, { start: 0, current: position, total: duration });
  }

  show() {
    this.$el.show();
  }

  hide() {
    this.$el.hide();
  }
}


// Para registrar el Playback en Clappr
customPlayback.canPlay = function (resource) {
  return true;
};